import React, { FC, useCallback } from 'react';
import { useLocale } from 'locale';
import { ShowAt, useScreenBreakpoint } from 'consts/breakpoints';
import { MadadAreasCarousel } from 'ds/components/carousels/madad-areas-carousel';
import { useShuffledArray } from 'hooks/useShuffledArray';
import Card from 'screens/MadadPage/card';
import { CardWrapper } from './styled';
import { legacyOffices } from './mockData';
import { MAX_VISIBLE_OFFICES } from './constants';
import { Title } from './Title';
import { Divider } from 'screens/MadadPage/landing/Divider';
import { useSendEvent } from 'analytics/useSendEvent';

export const LegacyPartnersCarousel: FC = () => {
  const isMobile = useScreenBreakpoint() < 3;
  const { t } = useLocale();
  const sendEvent = useSendEvent();
  const offices = useShuffledArray(legacyOffices).slice(0, MAX_VISIBLE_OFFICES);

  const handleCarouselScroll = useCallback((direction: 'right' | 'left', action: 'click' | 'swipe') => {
    sendEvent('madad_carousel_scroll', 'madad', {
      event: { carousel_type: 'madad_legacy_partners', direction, action },
    });
  }, [ sendEvent ]);

  if (!offices || !offices.length) return null;

  return (
    <>
      <ShowAt from={3}>
        {(hasArrows =>
          <MadadAreasCarousel
            hasArrows={hasArrows}
            title={(
              <Title
                title={t('madad.2026.legacy.title')}
                subtitle={t('madad.2026.legacy.subtitle')}
              />
            )}
            onArrowClick={(direction) => handleCarouselScroll(direction, 'click')}
            onSwipe={(direction) => handleCarouselScroll(direction, 'swipe')}
          >
            {offices.map((item, index) => (
              <CardWrapper key={item.id}>
                <Card
                  {...item}
                  enablePhoneShowing={isMobile}
                  isCarousel
                  pageSource="madad_landing_page"
                  collectionSource="legacy_partners"
                  cardIndex={index + 1}
                  source="madad_card_landing_page"
                />
              </CardWrapper>
            ))}
          </MadadAreasCarousel>
        )}
      </ShowAt>
      <Divider />
    </>
  );
};
